import useMediaQuery from "@material-ui/core/useMediaQuery";
import useTheme from "@material-ui/core/styles/useTheme";

function IS_DESKTOP() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up("md"));
}

export { IS_DESKTOP };
